var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-card", staticStyle: { "min-height": "750px" } },
        [
          _vm._m(0),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                [
                  _c("multiselect", {
                    staticStyle: { "min-width": "400px" },
                    attrs: {
                      options: _vm.customers,
                      multiple: false,
                      "close-on-select": true,
                      placeholder: "Pick ship to...",
                      "custom-label": (obj) => obj.id + " - " + obj.name,
                      "track-by": "name",
                    },
                    on: { input: _vm.getFormParameters },
                    model: {
                      value: _vm.reportForm.selectedCustomer,
                      callback: function ($$v) {
                        _vm.$set(_vm.reportForm, "selectedCustomer", $$v)
                      },
                      expression: "reportForm.selectedCustomer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("multiselect", {
                    staticStyle: { "min-width": "400px" },
                    attrs: {
                      options: _vm.customers,
                      multiple: false,
                      "close-on-select": true,
                      placeholder: "Pick sold to...",
                      "custom-label": (obj) => obj.id + " - " + obj.name,
                      "track-by": "name",
                    },
                    on: { input: _vm.getFormParameters },
                    model: {
                      value: _vm.reportForm.selectedCustomerSoldTo,
                      callback: function ($$v) {
                        _vm.$set(_vm.reportForm, "selectedCustomerSoldTo", $$v)
                      },
                      expression: "reportForm.selectedCustomerSoldTo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("b-datepicker", {
                    attrs: {
                      name: "date",
                      icon: "calendar-alt",
                      placeholder: "Start date",
                      "date-formatter": (date) =>
                        _vm.$dayjs(date).format("DD/MM/YYYY"),
                    },
                    model: {
                      value: _vm.reportForm.reportStartDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.reportForm, "reportStartDate", $$v)
                      },
                      expression: "reportForm.reportStartDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("b-datepicker", {
                    attrs: {
                      name: "date",
                      icon: "calendar-alt",
                      placeholder: "End date",
                      "date-formatter": (date) =>
                        _vm.$dayjs(date).format("DD/MM/YYYY"),
                    },
                    model: {
                      value: _vm.reportForm.reportEndDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.reportForm, "reportEndDate", $$v)
                      },
                      expression: "reportForm.reportEndDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("b-datepicker", {
                    attrs: {
                      name: "date",
                      icon: "calendar-alt",
                      placeholder: "History start date",
                      "date-formatter": (date) =>
                        _vm.$dayjs(date).format("DD/MM/YYYY"),
                      "years-range": [-50, 50],
                    },
                    model: {
                      value: _vm.reportForm.historyStartDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.reportForm, "historyStartDate", $$v)
                      },
                      expression: "reportForm.historyStartDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { type: "is-primary" },
                      model: {
                        value: _vm.reportForm.translation,
                        callback: function ($$v) {
                          _vm.$set(_vm.reportForm, "translation", $$v)
                        },
                        expression: "reportForm.translation",
                      },
                    },
                    [_vm._v(" Translation ")]
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-switch",
                    {
                      model: {
                        value: _vm.reportForm.tabByYear,
                        callback: function ($$v) {
                          _vm.$set(_vm.reportForm, "tabByYear", $$v)
                        },
                        expression: "reportForm.tabByYear",
                      },
                    },
                    [_vm._v(" Tab by year ")]
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-switch",
                    {
                      model: {
                        value: _vm.reportForm.withoutGPS1,
                        callback: function ($$v) {
                          _vm.$set(_vm.reportForm, "withoutGPS1", $$v)
                        },
                        expression: "reportForm.withoutGPS1",
                      },
                    },
                    [_vm._v(" Without GPS1 ")]
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-switch",
                    {
                      model: {
                        value: _vm.reportForm.NCR_IN_COL,
                        callback: function ($$v) {
                          _vm.$set(_vm.reportForm, "NCR_IN_COL", $$v)
                        },
                        expression: "reportForm.NCR_IN_COL",
                      },
                    },
                    [_vm._v(" With NCR in COLLECTION pages ")]
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "0", name: "name" },
                      model: {
                        value: _vm.reportForm.cratesLoss,
                        callback: function ($$v) {
                          _vm.$set(_vm.reportForm, "cratesLoss", $$v)
                        },
                        expression: "reportForm.cratesLoss",
                      },
                    },
                    [_vm._v(" No crates loss ")]
                  ),
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "1", name: "name" },
                      model: {
                        value: _vm.reportForm.cratesLoss,
                        callback: function ($$v) {
                          _vm.$set(_vm.reportForm, "cratesLoss", $$v)
                        },
                        expression: "reportForm.cratesLoss",
                      },
                    },
                    [_vm._v(" Month crates loss ")]
                  ),
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "2", name: "name" },
                      model: {
                        value: _vm.reportForm.cratesLoss,
                        callback: function ($$v) {
                          _vm.$set(_vm.reportForm, "cratesLoss", $$v)
                        },
                        expression: "reportForm.cratesLoss",
                      },
                    },
                    [_vm._v(" All crates loss ")]
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("ReportFormColumn", {
                    attrs: { depth: 0, data: _vm.columns },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "div",
              { staticClass: "is-flex is-align-content-center ml-auto" },
              [
                _c(
                  "b-checkbox",
                  {
                    staticClass: "mr-5",
                    model: {
                      value: _vm.isTest,
                      callback: function ($$v) {
                        _vm.isTest = $$v
                      },
                      expression: "isTest",
                    },
                  },
                  [_vm._v(" Test ")]
                ),
                _c(
                  "b-button",
                  {
                    attrs: {
                      type: _vm.isTest ? "is-primary" : "is-info",
                      "icon-left": _vm.isTest ? "vial" : "play",
                      "native-type": "submit",
                      disabled: _vm.isDisabled(),
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.isTest ? "Go testing" : "Generate") + " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [_vm._v(" New report ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }